import CountUp from "react-countup";
import { Card, CardBody, Col, Row } from "reactstrap";
import { H5, LI, ProgressBar, UL } from "../../../../AbstractElements";
import { Loss, Profit } from "../../../../Constants/Constants";
import { TicketListData } from "../../../../Data/Miscellaneous/SupportTicket";

const TicketList = () => {
  return (
    <Row>
      {TicketListData.map((data) => (
        <Col xl="4" sm="6" className="box-col-6" key={data.id}>
          <Card className={`ecommerce-widget bg-light-${data.color} txt-${data.color} shadow-none`}>
            <CardBody className="support-ticket-font">
              <Row>
                <Col xs="5">
                  <span>{data.title}</span>
                  <H5 className="total-num counter">
                    <CountUp end={data.count} />
                  </H5>
                </Col>
                <Col xs="7">
                  <div className="text-end">
                    <UL className="simple-list">
                      <LI className={`txt-${data.color}`}>
                        {Profit}
                        <span className="product-stts txt-success ms-2">
                          {"8989"}
                          <i className="icon-angle-up f-12 ms-1"></i>
                        </span>
                      </LI>
                      <LI className={`txt-${data.color}`}>
                        {Loss}
                        <span className="product-stts txt-danger ms-2">
                          {"2560"}
                          <i className="icon-angle-down f-12 ms-1"></i>
                        </span>
                      </LI>
                    </UL>
                  </div>
                </Col>
              </Row>
              <div className="progress-showcase mt-4">
                <ProgressBar className={`sm-progress-bar progress-striped-${data.color}`} color="transparent" value="70" />
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};
export default TicketList;
